import React from 'react';
import { Row, Col, Card } from 'antd';
import ViolationStatistic from '../Statistics/ViolationStatistic';
import TrainingStatistic from '../Statistics/TrainingStatistic';
import ManpowerStatistic from '../Statistics/ManpowerStatistic';
import Item from '../Statistics/Item';
import DetailItem from '../../../components/Detail/Item';
import { useSelector } from 'react-redux';
import Detail from './Detail';
import RequestCount from './RequestCount';
import TotalCount from './TotalCount';

const Index = () => {
  const { authUser } = useSelector(({ auth }) => auth);
  
  return (
    <>
      <Row>
        <Col md={8} xs={24}>
          <ViolationStatistic />
        </Col>
        <Col md={8} xs={24}>
          <TrainingStatistic />
        </Col>
        <Col md={8} xs={24}>
          <ManpowerStatistic />
        </Col>
        <Col md={16} xs={24}>
          <Detail id={authUser.vendor.id}/>
        </Col>
        <Col md={8} xs={12}>
          <Card className="gx-card">
            <Row>
              <Col md={12} xs={24}>
                <TotalCount />
              </Col>
              <Col md={12} xs={24}>
                <RequestCount />
              </Col>
            </Row>
          </Card>
        </Col>
      </Row>

    </>
  );
}

export default Index;